import { query } from "@sinao/core-js";
// import currencies from "../dummy/currencies.json";
import i18n from "@/i18n";

const langs = {
	state: () => ({
		printableLangs: [
			{
				key: "fr",
				name: "Français"
			}
        ],
        printableLang: null,
        defaultPrintableLang: {
            key: "fr",
            name: "Français"
        },
		lang_history: [i18n.locale ?? null]
	}),
    getters: {
        computedPrintableLang(state) {
            return state.printableLang ?? state.defaultPrintableLang;
        },
		previousLang(state) {
			return state.lang_history[state.lang_history.length - 2 ??state.lang_history.length - 1  ?? 0];
		}
    },
	mutations: {
		updatePrintableLangs(state, langs) {
			state.printableLangs.push(...langs);
        },
        setPrintableLang(state, value) {
            state.printableLang = value;
			state.lang_history.push(value.key);
			i18n.locale = value.key;
        },
		setPreviousPrintableLang(state, value) {
			if (value !== null)
				state.previousPrintableLang = value;
		}
	},
    actions: {
        setPrintableLangByDocument({ commit }, document) {
            if (document.metadata?.lang) {
                commit("setPrintableLang", document.metadata?.lang);
            }
        },

		async getPrintableLangs({ rootState, commit }) {
			try {
				const response = await query({
                    operationId: "app.settings.getSalesDocumentLangs",
					params :  {
						appId: rootState.app.id,
					}
				});
				commit("updatePrintableLangs", response);

				return response.data;
			} catch (error) {
				throw new Error(error);
			}
		},
	}
};

export default langs;
